import Vue from "vue";
import * as BankService from "@/shared/api/bankService";
import {
    PendingPersonalContributionState
} from "@/admin/types";
import {
    PendingPersonalContribution,
    PendingPersonalContributionPut,
    PendingPersonalContributionPutAction,
    FetchState
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: PendingPersonalContributionState = {
    fetchState: FetchState.Uninitialized,
    pageNumber: -1,
    items: null,
    detailItem: null
};

export const usePendingPersonalContributionStore = defineStore("pendingPersonalContribution", {
    state: (): PendingPersonalContributionState => (_.cloneDeep(initialState)),
    getters: {
        getLoadedItems: state => state.items,
        storedDetail: state => state.detailItem,
        showNextPage: state => state.items && state.items.length > 24
    },
    actions: {
        setItems (args: { page: number, items: PendingPersonalContribution[] }) {
            this.items = args.items;
            this.pageNumber = args.page;
            this.fetchState = args.items ? FetchState.Loading : FetchState.Loaded;
        },
        setDetail (item: PendingPersonalContribution) {
            if (item) {
                item.note = item.note || "";
            }
            this.detailItem = item;
        },
        updateDetail (update: PendingPersonalContributionPut) {
            const detail = this.detailItem;
            Vue.set(this.detailItem, "isDeleted", update.action === PendingPersonalContributionPutAction.Delete);
            detail.isOnHold = update.action === PendingPersonalContributionPutAction.Hold;
            detail.note = update.note;
        },
        loadItems ({ pageNumber }: { pageNumber: number }) {
            if (this.pageNumber === pageNumber && this.fetchState === FetchState.Loading) {
                return Promise.resolve();
            }

            this.setItems({ page: pageNumber, items: null });

            return BankService.listPendingContributions(pageNumber)
                .then(v => {
                    if (this.pageNumber === pageNumber) {
                        this.setItems({ page: pageNumber, items: v.data });
                    }
                })
                .catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        loadDetailById (contributionId: number) {
            this.setDetail(null);
            return BankService.getPendingContributionById(contributionId)
                .then(v => {
                    this.setDetail(v.data);
                })
                .catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        updatePendingItem (p: PendingPersonalContributionPut) {
            return BankService.putPendingContributionById(p)
                .then(v => {
                    this.setItems({ page: -1, items: null });
                    this.updateDetail(p);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});